import React, { useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Button, Grid, Tab, Dialog,DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { ICliente } from "../../entities/catalogos/ICliente";
import { IUsuario } from "../../entities/catalogos/IUsuario";
import Box from "@material-ui/core/Box";
import { ContactPhone, FormatListBulleted, RecentActors } from '@material-ui/icons';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import CotizacionLista from '../ComponentList/CotizacionLista';
import SolicitudLista from '../ComponentList/SolicitudLista';
import DireccionesLista from '../ComponentList/DireccionesLista';
import ContactosLista from '../ComponentList/ContactosLista';
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import BodyCotizacion from './BodyCotizacion';
import { Solicitud } from '../../entities/solicitudes/Solicitud';
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { setRecoleccionDestino, setRecoleccionOrigen } from '../../redux/actions/recoleccionActions';
import { initialSolicitud } from '../../redux/reducers/solicitudReducer';
import { saveMercancias } from '../../redux/actions/mercanciaActions';
import { initialRecoleccionState } from '../../redux/reducers/recoleccionReducer';
import { initialMercancia } from '../../redux/reducers/mercanciaReducer';
import { setUsuario } from '../../redux/actions/usuarioActions';
import { IHelp } from '../help/Help';
import useCommonApi from '../../api/useCommonApi';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import SelectControl from '../controls/SelectControl';
import LoadingDialog from '../controls/LoadingDialog';
import CargaMasivaLista from '../ComponentList/CargaMasivaLista';
import DialogContentText from "@material-ui/core/DialogContentText";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            flexGrow: 1,
        },
        container: {

        },
        principal: {
            minHeight: "400px",
            height: '100%',
            backgroundColor: "#fff",
            margin: "0px",
            padding: "0px",
            width: "100%"
        },
        header: {
            width: "100%",
            background: "url('/image/banner.png') no-repeat center center",
            boxShadow: "none"
        },
        tabs_container: {
            width: "100%",
            backgroundColor: "#fff",
            boxShadow: "none",
            padding: "0px",
            textAlign: "left",
            margin: "0px",
        },
        tabs: {
            paddingTop: "25px",
            paddingBottom: "20px",
            width: "100%",

            height: '100%',
            backgroundColor: "#ECECEC",
            boxShadow: "none",
            textAlign: "center",
            display: "block",
            background: "url('/image/banner.png') no-repeat center center"
        },
        tab: {
            width: "100px",
            height: '120px',
            backgroundColor: "#f3f3f3",
            boxShadow: "0 2px 16px 0 rgba(167,167,167,0.33)",
            marginRight: "25px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            textTransform: "capitalize",
            fontSize: "15px",
            fontWeight: 600
        },
        tab_content: {
            width: "100%",
            height: '450px',
            backgroundColor: "#fff",
            boxShadow: "none",
        },
        tab_cotizacion: {
            textTransform: "capitalize"
        },
        toolbar: {
            minHeight: '48px'
        },
        border: {
            borderBottom: "1px solid #ddd",
        },
        body_container: {
            padding: "0px",
        },
        tabParent: {
            backgroundColor: "#fff",
            boxShadow: "none"
        },
        link: {
            color: "#00653b",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer"
        },
    }),
);

interface StateProps {
    cliente: ICliente
    usuario: IUsuario
    ayuda: IHelp,
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveMercancias: typeof saveMercancias
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
}

type Props = StateProps & DispatchProps

const Body = (props: Props) => {
    const [showLoading, setLoading] = useState(false);
    const classes = useStyles();
    const ocultarPortal = localStorage.getItem("ocultarPortal") === "true" || localStorage.getItem("ocultarPortal") === "1";
    const [tabActivo, setTabActivo] = useState("1");
    const history = useHistory();
    const [subTabCotizacion, setSubTabCotizacion] = useState("Cotizaciones");
    const handleTab = (event: React.ChangeEvent<{}>, newValue: string) => {
        setTabActivo(newValue);
    };
    const apiSource = useCommonApi();

    const handleTabCotizacion = (event: React.ChangeEvent<{}>, newValue: string) => {
        setSubTabCotizacion(newValue);
    };
    const [lang, setLang] = useState({ id: 'es-MX' });


    const logOut = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("usuarioId");
        localStorage.removeItem("clienteId");
        localStorage.removeItem("tipo_usuario");
        localStorage.removeItem("usuario_nombre");

        //

        getParametros().then(data => {
            let loginUrl = data.find(a => a.nombre === 'URL Login Portal Nuevo');

            if (loginUrl !== undefined) {
                window.location.replace(loginUrl.valor);
            }
            else {
                history.push("/getting-started/installation/");
            }
        })
    }

    const getParametros = async () => {
        const result = await apiSource.obtenerAsync<any>('parametro/active');
        return result;
    }
    useEffect(() => {
        if (props.usuario.esInvitado) {
            const nuevaCotizacion = new Solicitud(initialSolicitud);
            nuevaCotizacion.modificar = false;
            nuevaCotizacion.seccionId = 0.5;
            props.setSolicitud(nuevaCotizacion);
            props.setSolicitudCopia(nuevaCotizacion);
            props.setRecoleccionOrigen(initialRecoleccionState);
            props.setRecoleccionDestino(initialRecoleccionState);
            props.saveMercancias([initialMercancia]);
            setUsuario({ ...props.usuario });
            history.push("/nueva-cotizacion");
        }
    }, []);

    useEffect(() => {
        const res = localStorage.getItem("idioma");
        const idioma = res === null ? 'es-MX' : res;
        const isLoading = localStorage.getItem("renderiza") === null ? '' : localStorage.getItem("renderiza");
        if(isLoading !== ""){
            setLoading(true);
        }
        else{
            setLoading(false);
        }
        setLang({ id: idioma });
    }, []);

    const tituloTerminos = traducirLabel(351).charAt(0).toUpperCase() + traducirLabel(351).slice(1);
    const [openModalTyC, setOpenModalTyC] = useState(false);
    const [aceptoTerminos, setAceptoTerminos] = useState(false);
    const aceptaterminos = () => {
        window.open('http://ndocum.almex.com.mx/documentacion/pages/GenerarPDF.aspx?TipoPDF=8');
    }
    
    useEffect(() => {
    if (
        subTabCotizacion === "Cargas Masivas" &&
        props.usuario.id !== null
    ) {
        setAceptoTerminos(false);
        setOpenModalTyC(true);
    }
    }, [subTabCotizacion]);

    const actualizarIdioma = async (e) => {
        const usuarioNombreStorage = localStorage.getItem("usuario_nombre");
        const clienteStorage = localStorage.getItem("clienteId");
        const params = {
            clienteID: clienteStorage,
            usuario: usuarioNombreStorage,
            idioma: e.target.value
        };
        const result = await apiSource.postAsync<any>('idioma/change', params);
        setLang({ ...lang, id: e.target.value });
        localStorage.removeItem("idioma");
        localStorage.setItem("idioma", e.target.value);
        if (result.length > 0) {
            const url = new URL(window.location.href);
            url.searchParams.delete("token");
            window.history.replaceState({}, document.title, url.toString());

            localStorage.removeItem("etiquetas");
            localStorage.setItem("etiquetas", JSON.stringify(result));
            window.location.reload();
        }
    };
    const esCargaMasiva = localStorage.getItem("verCargaMasiva");
    // Arma los tabs válidos
    const tabs: React.ReactElement[] = [];
    if(props.usuario.id !== null){
    tabs.push(
    <Tab key="cot" className={classes.tab_cotizacion} label={traducirLabel(60)} value="Cotizaciones" />,
    <Tab key="sol" className={classes.tab_cotizacion} label={traducirLabel(285)} value="Solicitudes" />,
    );
    }

    if (props.usuario.id !== null && esCargaMasiva == "true") {
    tabs.push(
        <Tab key="carga" className={classes.tab_cotizacion} label="Solicitudes Masivas" value="Cargas Masivas" />
    );
    }

    const mainTabs: React.ReactElement[] = [];
    if (!ocultarPortal) {
        mainTabs.push(
            <Tab key="main1" className={classes.tab} label={traducirLabel(184)} value="1" icon={<FormatListBulleted />} />,
            <Tab key="main2" className={classes.tab} label={traducirLabel(183)} value="2" icon={<RecentActors />} />,
            <Tab key="main3" className={classes.tab} label={traducirLabel(70)} value="3" icon={<ContactPhone />} />
        );
    }
    else{
        mainTabs.push(
            <Tab key="main1" className={classes.tab} label={traducirLabel(184)} value="1" icon={<FormatListBulleted />} />
            
        );
    }

    return (<>
        {!props.usuario.esInvitado && props.usuario.esInvitado !== undefined &&
            <AppBar position="static" color='default' className={classes.header}>
                <Toolbar className={classes.toolbar}>
                    <Box className={classes.title}>
                        <img src="/image/almex-logo.png" alt={""} />
                    </Box>
                    <Breadcrumbs separator="|" aria-label="breadcrumb">
                        <Typography component={'span'} color="textPrimary">
                            {traducirLabel(20)}, <b>{props.usuario.nombre}</b>
                        </Typography>
                         <Box>
                            <SelectControl name="lang" source="idioma/many" label={traducirLabel(322)} onChange={actualizarIdioma}
                                value={lang?.id} />
                        </Box>
                        <Button onClick={logOut}>
                            {traducirLabel(271)}
                        </Button>
                    </Breadcrumbs>
                </Toolbar>
            </AppBar>
        }

        {!props.usuario.esInvitado && props.usuario.esInvitado !== undefined &&
            <div className={classes.root}>
                <Grid container justify="center" alignItems="center" style={{ width: "100%", maxWidth: "100%", backgroundColor: "#fff" }}>
                    <Grid item xs={12}>
                        <TabContext value={tabActivo}  >
                            <AppBar position="static" className={classes.tabParent} >
                                <TabList indicatorColor="primary" textColor="primary" className={classes.tabs}
                                    value={tabActivo} onChange={handleTab}
                                    variant="scrollable" scrollButtons="auto">
                                    {mainTabs}
                                </TabList>
                            </AppBar>
                            <TabPanel value="1" >
                                <TabContext value={subTabCotizacion}>
                                    <AppBar position="static" className={classes.tabParent}>
                                        <TabList indicatorColor="primary" textColor="primary" className={classes.border}
                                            value={subTabCotizacion} onChange={handleTabCotizacion} style={{ marginLeft: "50px" }}
                                            variant="scrollable" scrollButtons="auto">
                                            {tabs}

                                        </TabList>
                                    </AppBar>

                                    <TabPanel value="Cotizaciones" style={{ minHeight: "400px" }}>
                                        {props.usuario.id !== null && props.cliente.id !== null &&
                                            <CotizacionLista cliente={props.cliente} usuario={props.usuario} ayuda={props.ayuda} />
                                        }
                                    </TabPanel>

                                    <TabPanel value="Solicitudes" style={{ minHeight: "400px" }}>
                                        {props.usuario.id !== null &&
                                            <SolicitudLista cliente={props.cliente} usuario={props.usuario} ayuda={props.ayuda} />
                                        }
                                    </TabPanel>

                                    <TabPanel value="Cargas Masivas" style={{ minHeight: "400px" }} >
                                        {props.usuario.id !== null && esCargaMasiva === "true" && (
                                            <>
                                                {aceptoTerminos ? (
                                                    <CargaMasivaLista 
                                                        cliente={props.cliente} 
                                                        usuario={props.usuario} 
                                                        ayuda={props.ayuda} 
                                                    />
                                                ) : (
                                                    <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', marginTop: '20px' }}>
                                                        
                                                    </Typography>
                                                )}
                                            </>
                                        )}
                                    </TabPanel>
                                </TabContext>
                            </TabPanel>

                            <TabPanel value="2" style={{ minHeight: "400px" }}>
                                <DireccionesLista cliente={props.cliente} ayuda={props.ayuda} />
                            </TabPanel>

                            <TabPanel value="3" style={{ minHeight: "400px" }}>
                                <ContactosLista cliente={props.cliente} ayuda={props.ayuda} />
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </div>
        }

        {
            props.usuario.esInvitado &&
            <Grid container justify="center" style={{ width: "100%", maxWidth: "100%", backgroundColor: "#fff" }}>
                <Grid item xs={12} >
                    <BodyCotizacion cotizacionId={0} />
                </Grid>
            </Grid>
        }
        {showLoading &&
            /*Procesando */
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }

<Dialog open={openModalTyC} onClose={(event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    setOpenModalTyC(false);
  }} fullWidth maxWidth="md">
  <DialogTitle>{traducirLabel(351)}</DialogTitle>
  <DialogContent dividers>
    <DialogContentText style={{ whiteSpace: "pre-line", textAlign: "justify" }}>
      {traducirMessage(327)} <br /><br /> {traducirMessage(326)}<br />
      {traducirMessage(328)}&nbsp;
      <span className={classes.link} onClick={aceptaterminos}>
        {/* Terminos y condiciones */traducirLabel(351)}
      </span>.
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button 
      onClick={() => {
        setAceptoTerminos(true);
        setOpenModalTyC(false);
      }} 
      color="primary" 
      variant="contained"
    >
      {traducirButton(17)}
    </Button>
  </DialogActions>
</Dialog>

    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    usuario: state.usuario,
    ayuda: state.ayuda,
    idiomaId: state.idioma
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    saveMercancias: saveMercancias,
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);

